<template>
  <el-dialog
    width="50%"
    :title="title"
    :visible="visible"
    @close="close"
  >
    <el-form
      ref="from"
      :model="from"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item
        v-for="(item, index) in formRules"
        :key="index"
        :label="item.name"
        :prop="item.prop"
      >
        <template v-if="item.inputType">
          <slot :name="item.prop" :item="from[item.prop]">
            <el-input
              v-model.trim="from[item.prop]"
              placeholder="请输入"
              :disabled="item.disabled ? item.disabled : false"
              :type="item.inputType || 'text'"
            />
          </slot>
        </template>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        type="primary"
        @click="submit"
      >
        确定
      </el-button>
      <el-button
        class="filter-item"
        @click="close"
      >
        取消
      </el-button>
      <!-- <el-popconfirm
              v-if="item.func === 'handleDelete'"
              :key="item.func"
              style="margin: 0 10px;"
              title="确定删除本条数据吗？"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-info"
              icon-color="red"
              @onConfirm="buttonMethod(item.func, scope.$index, scope.row)"
            >
              <el-button slot="reference" :type="item.type" size="small">
                {{ item.name }}
              </el-button>
            </el-popconfirm> -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'BaseDialog',
  props: {
    formData: {
      type: [Boolean, Object],
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    formRules: {
      type: Array,
      required: true
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      from: JSON.parse(JSON.stringify(this.formData))
    }
  },
  computed: {
    rules() {
      const box = {}
      this.formRules.forEach(item => {
        if (item.rules) {
          box[item.prop] = item.rules
        }
      })
      return box
    }
  },
  watch: {
    formData: {
      handler(val) {
        console.log(val)
        this.from = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    submit() {
      this.$refs.from.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$emit('submit', this.from)
      })
    },
    close() {
      // this.$parent.resetForm()
      this.$emit('update:formData', {})
      this.$emit('update:visible', false)
      this.$emit('update:initial', [])
    }
  }
}
</script>